import React, { useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Download, Loader2 } from "lucide-react";

const OPTS = [{ k: "all", l: "All time" }, { k: "day", l: "One day" }, { k: "month", l: "One month" }];

export const FullListDownload = () => {
  const [period, setPeriod] = useState("all");
  const [date, setDate] = useState(new Date().toLocaleDateString("en-CA"));
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try {
      const r = await api.get("/export/full-list.xlsx", { params: { period, date }, responseType: "blob" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(r.data); a.download = `bengal_umrah_members_customers_${period}_${date}.xlsx`; a.click();
    } catch { toast.error("Download failed"); } finally { setBusy(false); }
  };
  return (
    <Card className="bg-card/40 border-gold/20 p-4 flex flex-wrap items-center gap-2" data-testid="full-list-download">
      <p className="eyebrow text-gold mr-auto">Members & customers full list (with joining numbers)</p>
      {OPTS.map((o) => (
        <Button key={o.k} size="sm" variant="outline" onClick={() => setPeriod(o.k)} data-testid={`full-list-period-${o.k}`}
          className={`h-8 text-xs ${period === o.k ? "bg-gold text-[#0a2e22] border-gold" : "border-gold/30 text-gold"}`}>{o.l}</Button>
      ))}
      {period !== "all" && <Input type={period === "month" ? "month" : "date"} value={period === "month" ? date.slice(0, 7) : date}
        onChange={(e) => setDate(period === "month" ? `${e.target.value}-01` : e.target.value)} className="w-40 h-8 bg-card/60" data-testid="full-list-date" />}
      <Button size="sm" onClick={go} disabled={busy} data-testid="full-list-download-btn" className="h-8 bg-gold text-[#0a2e22] hover:bg-gold/90 gap-1.5 text-xs">
        {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Download className="w-3.5 h-3.5" />} Download Excel
      </Button>
    </Card>
  );
};
